module.exports = __webpack_public_path__ + "img/bg-audio-7.fcd6519b.png";